export default __webpack_public_path__ + "static/media/BGMusic.8093a321.mp3";